// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"VsDgTdsAbtgomvXCHxfC","row":"i88c77NtJ7s2lF4hLndF","full":"oUl2A8e7vBz55Jga2Ciq","half":"zN8JQ1L7udwVoi_2hM3V"};